import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import InputField from 'components/InputField';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import { injectIntl } from 'react-intl';
import CollapsablePanel from './CollapsePanel';


class ProfileForm extends Component {

    componentDidMount() {
        if (typeof window !== "undefined") {
            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    render() {
        let { initialValues, pristine, submitting, handleSubmit, onSubmit,  profile } = this.props;

        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let hasChanges = !disabled;

        return (<div>
            <style>{`
      
            textarea{
                font-size:10px;
                font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New;
                background-color: beige;
                border: none;
            }
            
            `}</style>


            <form onSubmit={handleSubmit(onSubmit)}>
                <h3>Public API</h3>
                {typeof window !== "undefined" && profile && profile.shopify && <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            Client ID<br />
                            <Field
                                className="form-control"

                                name="shopify.id"
                                component={InputField}
                                type="text"
                                value="shopify.id"
                                readOnly={true}
                            />
                            Shop Name<br />
                            <Field
                                className="form-control"
                                name="shopify.shopName"
                                component={InputField}
                                type="text"
                                value="shopify.shopName"
                                readOnly={true}
                            />
                            <small className="label label-danger">Do not share Client ID!</small>
                            <br />
                            <h3>Endpoints</h3>

                            <CollapsablePanel location="default" section="api-paid" title="Get locations">
                                URL: <b>{`${window.origin}/api/v1/locations`}</b><br />
                                Method: <b>GET</b><br />
                                Request Headers:<br />
                                <textarea rows="10" cols="68" value={`{
    "clientId": ${profile.shopify.id},
    "shopName": "${profile.shopify.shopName}"
}
`}></textarea><br />
                                Responses:<br />
                                <textarea rows="7" cols="68" value={`403 (Unauthorized) - Wrong client id or shop name
500 (Internal Server Error) - Unknown internal server error
200 (OK) - Array of locations
`}>
                                </textarea>

                            </CollapsablePanel>

                            <CollapsablePanel location="default" section="api-paid" title="Download invoice">
                                URL: <b>{`${window.origin}/api/v1/invoices/:invoiceNumber/pdf`}</b><br />
                                Method: <b>GET</b><br />
                                Request Headers:<br />
                                <textarea rows="10" cols="68" value={`{
    "clientId": ${profile.shopify.id},
    "shopName": "${profile.shopify.shopName}"
}
`}></textarea><br />
                                Responses:<br />
                                <textarea rows="7" cols="68" value={`403 (Unauthorized) - Wrong client id or shop name
500 (Internal Server Error) - Unknown internal server error
200 (OK) - PDF bytes
`}>
                                </textarea>

                            </CollapsablePanel>

                            <CollapsablePanel location="default" section="api-paid" title="Download invoice for a specific location">
                                URL: <b>{`${window.origin}/api/v1/:locationId/invoices/:invoiceNumber/pdf`}</b><br />
                                Method: <b>GET</b><br />
                                Request Headers:<br />
                                <textarea rows="10" cols="68" value={`{
    "clientId": ${profile.shopify.id},
    "shopName": "${profile.shopify.shopName}"
}
`}></textarea><br />
                                Responses:<br />
                                <textarea rows="7" cols="68" value={`403 (Unauthorized) - Wrong client id or shop name
500 (Internal Server Error) - Unknown internal server error
200 (OK) - PDF bytes
`}>
                                </textarea>

                            </CollapsablePanel>

                            <CollapsablePanel location="default" section="api-paid" title="Download order as">
                                URL: <b>{`${window.origin}/api/v1/orders/:orderId/:templateName/pdf`}</b><br />
                                Method: <b>GET</b><br />
                                Request Headers:<br />
                                <textarea rows="10" cols="68" value={`{
    "clientId": ${profile.shopify.id},
    "shopName": "${profile.shopify.shopName}"
}
`}></textarea><br />
                                Responses:<br />
                                <textarea rows="7" cols="68" value={`403 (Unauthorized) - Wrong client id or shop name
500 (Internal Server Error) - Unknown internal server error
200 (OK) - PDF bytes
`}>
                                </textarea>

                            </CollapsablePanel>


                            <CollapsablePanel location="default" section="api-paid" title="Mark a list of orders as paid">
                                URL: <b>{`${window.origin}/api/v1/orders/paid`}</b><br />
                                Method: <b>POST</b><br />
                                Request Headers:<br />
                                <textarea rows="10" cols="68" value={`{
    "clientId": ${profile.shopify.id},
    "shopName": "${profile.shopify.shopName}"
}
`}></textarea><br />
                                Request Body:<br />
                                <textarea rows="10" cols="68" value={`{
    "orders": [
        6004,
        6005
    ]
}
`}>
                                </textarea><br />
                                Responses:<br />
                                <textarea rows="7" cols="68" value={`403 (Unauthorized) - Wrong client id or shop name
500 (Internal Server Error) - Other internal server error
200 (OK) - Execution went ok, request will be process with delay
`}>
                                </textarea>

                            </CollapsablePanel>

                            <CollapsablePanel location="default" section="api-labels" title="Get EEU Gls Label as PDF">
                                URL: <b>{`${window.origin}/api/v1/${profile.shopify.shopName}/${profile.shopify.id}/labels/eeugls/:orderNumber/:create/:pickandreturn`}</b><br />
                                Method: <b>GET</b><br />
                                Url Param: <b>orderNumber</b> - the number of the order <br/>
                                Url Param: <b>create</b> - if label has to be created, false if already exists <br/>
                                Url Param: <b>pickandreturn</b> - request pick and return, usually false <br/>
                                Responses:<br />
                                <textarea rows="7" cols="68" value={`403 (Unauthorized) - Wrong client id or shop name
500 (Internal Server Error) - Other internal server error
200 (OK) - Execution went ok, PDF returned.
`}>
                                </textarea>

                            </CollapsablePanel>                            
                        </div>
                    </div>
                </div>}


                <br />
                <i style={{
                    position: 'fixed',
                    top: '20px',
                    left: '13px',
                    zIndex: '999',
                    fontSize: '23px',
                    color: 'white'

                }} onClick={() => {
                    window.location.href = '/' + this.props.intl.locale + '/dashboard';
                }
                } className="back-button fa fa-arrow-circle-left">&nbsp;</i>
            </form>


        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{intl.formatMessage({ id: 'common.loading' })}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>Developer Tools</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-12 col-xs-12">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));




// WEBPACK FOOTER //
// app/containers/DeveloperTools.jsx